var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankReceipts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62853 12.2458H24.9981C25.276 12.2458 25.5015 12.0203 25.5015 11.7424V10.1795C25.5015 10.0143 25.421 9.86127 25.2881 9.76855L15.1014 2.59068C14.9282 2.46977 14.6946 2.46977 14.5213 2.59068L4.33847 9.76855C4.20551 9.86127 4.12503 10.0183 4.12503 10.1795V11.7424C4.12484 12.0202 4.35052 12.2457 4.62847 12.2457L4.62853 12.2458ZM14.8114 5.93386C15.8224 5.93386 16.64 6.75148 16.64 7.76251C16.64 8.77353 15.8224 9.59115 14.8114 9.59115C13.8004 9.59115 12.9828 8.77353 12.9828 7.76251C12.9826 6.75167 13.8004 5.93386 14.8114 5.93386Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45407 23.1132V23.959H10.5939V23.1132C10.5939 22.9441 10.453 22.8029 10.2837 22.8029L5.76453 22.8031C5.59133 22.807 5.45429 22.9441 5.45429 23.1132L5.45407 23.1132Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5939 13.0391H5.45407V13.8849C5.45407 14.054 5.595 14.1951 5.76431 14.1951H10.2837C10.4528 14.1951 10.5939 14.0542 10.5939 13.8849L10.5939 13.0391Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2374 23.1133V23.9591L17.3853 23.9592V23.1135C17.3853 22.9443 17.2444 22.8032 17.0751 22.8032H12.5516C12.3784 22.8071 12.2374 22.9442 12.2374 23.1133Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7727 23.1133V23.9591L23.9207 23.9592V23.1135C23.9207 22.9443 23.7797 22.8032 23.6104 22.8032H19.087C18.9138 22.8071 18.7727 22.9442 18.7727 23.1133Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3853 13.0391H12.2374V13.8849C12.2374 14.054 12.3783 14.1951 12.5515 14.1951H17.0709C17.24 14.1951 17.3811 14.0542 17.3811 13.8849V13.0391H17.3853Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1682 13.8851V13.0393L19.0284 13.0391V13.8849C19.0284 14.054 19.1693 14.1951 19.3386 14.1951H23.8579C24.0311 14.1951 24.168 14.0583 24.168 13.8851L24.1682 13.8851Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3285 14.9888H9.71998V22.0095H6.3285V14.9888Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1152 14.9888H16.5067V22.0095H13.1152V14.9888Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5909 24.7567H4.59621C4.26594 24.7567 4 25.0227 4 25.3529V26.9038C4 27.234 4.26593 27.5 4.59621 27.5H25.5909C26.1591 26.9318 26.1591 25.2273 25.5909 24.7567Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2942 21.8182V14.9886H19.9027V21.8182C23.2942 21.8182 19.9027 21.8182 23.2942 21.8182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankReceipts);
export default __webpack_public_path__ + "static/media/BankReceipts.1e3e2c172ca1d00978c904b80ade769b.svg";
export { ForwardRef as ReactComponent };